/**
 * Very basic paging param class
 * 
 * TODO Consider supporting different paging mechanisms, such as skip token
 */
export class PageParams {
  page: number = 1;
  pageSize: number = 25;
}